import React from 'react';

import Box from 'components/Box';
import { RouterNavLink } from 'components/Link';
import { Line } from 'components/Search/SearchLoadingSection';
import { H5 } from 'components/Text';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_COUNTS,
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS,
} from 'utils/constants';
import { listingSearchHome } from 'utils/searchHomePages';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ListingCounts = ({
  listingCounts,
}: {
  listingCounts: Record<string, number> | null | undefined;
}) => {
  const types = ['JOB', 'INTERNSHIP', 'VOLOP', 'ORG', 'GROUP', 'GRAD_PROGRAM'];
  return (
    <Box
      data-qa-id="listing-counts"
      width="calc(100% + 16px)"
      minHeight={30}
      mx="-8px"
      textAlign="center"
    >
      {listingCounts ? (
        <Box
          display="flex"
          justifyContent={['center', null, null, 'space-between']}
          flexWrap="wrap"
        >
          {types.map((type) => {
            const count = listingCounts[type] || 0;
            return (
              <Box mx="8px" key={type}>
                <RouterNavLink
                  to={{
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                    pathname: listingSearchHome(type),
                    search: '?q=',
                    state: { searchFrom: 'Listing Count Link' },
                  }}
                >
                  <H5 tag="span">
                    <Box position="relative" display="inline-block">
                      <Box visibility="hidden">
                        {count.toLocaleString(CURRENT_LOCALE)}
                      </Box>
                      <Box position="absolute" top={0} right={0} aria-hidden>
                        {count.toLocaleString(CURRENT_LOCALE)}
                      </Box>
                    </Box>{' '}
                    {count === 1
                      ? LISTING_TYPE_HUMAN_NAME_MAP_COUNTS[type]
                      : LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS[type]}
                  </H5>
                </RouterNavLink>
              </Box>
            );
          })}
        </Box>
      ) : (
        <Box
          display="flex"
          justifyContent={['center', null, null, 'space-between']}
          flexWrap="wrap"
        >
          {/* @ts-expect-error ts-migrate(2554) FIXME: Expected 1-3 arguments, but got 0. */}
          {new Array(types.length).fill().map((_, index) => (
            <Line // eslint-disable-next-line react/no-array-index-key
              key={index}
              flex="0 0 auto"
              width={120}
              maxWidth="calc(50% - 16px)"
              height={16}
              m="8px"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

// eslint-disable-next-line import/no-default-export
export default ListingCounts;
